import Vue from 'vue'
import Router from 'vue-router'
import PainelInicial from '@/pages/painelInicial/TheHome'
import Login from '@/pages/TheLogin'
import VisaoGeral from '@/pages/visaoGeral/VisaoGeral'
import VisaoGeralInterna from '@/pages/visaoGeral/VisaoGeralInterna'
import Chamados from '@/pages/chamados/Chamados'
import Chamado from '@/pages/chamados/Chamado'
import Integrador from '@/pages/cadastros/Integrador'
import Distribuidor from '@/pages/cadastros/Distribuidor'
import Cliente from '@/pages/cadastros/Cliente'
import Usina from '@/pages/cadastros/Usina'
import UnidadeConsumidora from '@/pages/cadastros/UnidadeConsumidora'
import Interface from '@/pages/cadastros/Interface'
import StatusUsinas from '@/pages/cadastros/StatusUsinas'
import StatusInversores from '@/pages/cadastros/StatusInversores'
import Concessionaria from '@/pages/cadastros/Concessionaria'
import Inversores from '@/pages/cadastros/Inversores'
import Auditoria from '@/pages/auditoria/Auditoria'
import Log from '@/pages/log/Log'
import Relatorios from '@/pages/relatorios/Relatorios'
import RelatoriosFaturas from '@/pages/relatorios/atendimento/Faturas'
import RelatoriosCredito from '@/pages/relatorios/atendimento/Credito'
import RelatoriosProdutividade from '@/pages/relatorios/atendimento/Produtividade'
import RelatoriosRetornoInvestimento from '@/pages/relatorios/atendimento/RetornoInvestimento'
import RelatoriosChamados from '@/pages/relatorios/atendimento/Chamados'
import RelatoriosResumoComercial from '@/pages/relatorios/comercial/ResumoComercial'
import RelatoriosResumoComercialDetalhado from '@/pages/relatorios/comercial/ResumoComercialDetalhado'
import RelatoriosClientes from '@/pages/relatorios/operacional/Clientes'
import RelatoriosUsuarios from '@/pages/relatorios/operacional/Usuarios'
import RelatoriosInversores from '@/pages/relatorios/operacional/Inversores'
import RelatoriosUsinas from '@/pages/relatorios/operacional/Usinas'
import RelatoriosConcessionarias from '@/pages/relatorios/operacional/Concessionarias'
import RelatoriosUnidades from '@/pages/relatorios/operacional/Unidades'
import RelatoriosIntegradores from '@/pages/relatorios/operacional/Integradores'
import RelatoriosGeralCliente from '@/pages/relatorios/atendimento/GeralCliente'
import AcompanhamentoUsinas from '@/pages/relatorios/AcompanhamentoUsina'
import Grupos from '@/pages/gestor/Grupos'
import Usuarios from '@/pages/gestor/Usuarios'
import Discord from '@/pages/configuracoes/Discord'
import Osticket from '@/pages/configuracoes/Osticket'
import ConfiguracoesGerais from '@/pages/configuracoes/ConfiguracoesGerais'
import ChamadosConfig from '@/pages/configuracoes/Chamados'
import ConfiguracoesApp from '@/pages/configuracoes/ConfigApp'
import ConfiguracoesAppUsuarios from '@/pages/configuracoes/ConfigAppUsuarios'
import ConfiguracoesChat from '@/pages/configuracoes/ConfigChat'
import Imposto from '@/pages/configuracoes/Imposto'
// import Status from '@/pages/cadastros/Status'
import { validToken } from '@config/token'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
Vue.use(NProgress)
NProgress.configure({
  showSpinner: false
})

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/',
      name: 'PainelInicial',
      component: PainelInicial,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/visao-geral',
      name: 'VisaoGeral',
      component: VisaoGeral,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/visao-geral/:uuid',
      name: 'VisaoGeralInterna',
      component: VisaoGeralInterna,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/chamados',
      name: 'Chamados',
      component: Chamados,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/chamados/:uuid',
      name: 'Chamado',
      component: Chamado,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cadastros/integrador',
      name: 'Integrador',
      component: Integrador,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cadastros/distribuidor',
      name: 'Distribuidor',
      component: Distribuidor,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cadastros/cliente',
      name: 'Cliente',
      component: Cliente,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cadastros/usina',
      name: 'Usina',
      component: Usina,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cadastros/unidade-consumidora',
      name: 'UnidadeConsumidora',
      component: UnidadeConsumidora,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cadastros/interface',
      name: 'Interface',
      component: Interface,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/status-das-usinas',
      name: 'StatusUsinas',
      component: StatusUsinas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/status-dos-inversores',
      name: 'StatusInversores',
      component: StatusInversores,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cadastros/concessionaria',
      name: 'Concessionaria',
      component: Concessionaria,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/cadastros/inversores',
      name: 'Inversores',
      component: Inversores,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/cadastros/status',
    //   name: 'Status',
    //   component: Status,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: '/auditoria',
      name: 'Auditoria',
      component: Auditoria,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/log',
      name: 'Log',
      component: Log,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios',
      name: 'Relatorios',
      component: Relatorios,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/faturas',
      name: 'RelatoriosFaturas',
      component: RelatoriosFaturas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/sistema-credito',
      name: 'RelatoriosCredito',
      component: RelatoriosCredito,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/produtividade',
      name: 'RelatoriosProdutividade',
      component: RelatoriosProdutividade,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/retorno-investimento',
      name: 'RelatoriosRetornoInvestimento',
      component: RelatoriosRetornoInvestimento,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/resumo-comercial',
      name: 'RelatoriosResumoComercial',
      component: RelatoriosResumoComercial,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/resumo-comercial-detalhado',
      name: 'RelatoriosResumoComercialDetalhado',
      component: RelatoriosResumoComercialDetalhado,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/clientes',
      name: 'RelatoriosClientes',
      component: RelatoriosClientes,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/usuarios',
      name: 'RelatoriosUsuarios',
      component: RelatoriosUsuarios,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/chamados',
      name: 'RelatoriosChamados',
      component: RelatoriosChamados,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/inversores',
      name: 'RelatoriosInversores',
      component: RelatoriosInversores,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/usinas',
      name: 'RelatoriosUsinas',
      component: RelatoriosUsinas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/concessionarias',
      name: 'RelatoriosConcessionarias',
      component: RelatoriosConcessionarias,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/integradores',
      name: 'RelatoriosIntegradores',
      component: RelatoriosIntegradores,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/unidades',
      name: 'RelatoriosUnidades',
      component: RelatoriosUnidades,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/relatorios/geral-cliente',
      name: 'RelatoriosGeralCliente',
      component: RelatoriosGeralCliente,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/acompanhamento-usina',
      name: 'AcompanhamentoUsinas',
      component: AcompanhamentoUsinas,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/gestor/grupos',
      name: 'Grupos',
      component: Grupos,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/gestor/usuarios',
      name: 'Usuarios',
      component: Usuarios,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/discord',
      name: 'Discord',
      component: Discord,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/osticket',
      name: 'osTicket',
      component: Osticket,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/configuracoes-gerais',
      name: 'ConfiguracoesGerais',
      component: ConfiguracoesGerais,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/chamados',
      name: 'ChamadosConfig',
      component: ChamadosConfig,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/app',
      name: 'ConfiguracoesApp',
      component: ConfiguracoesApp,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/app-usuarios',
      name: 'ConfiguracoesAppUsuarios',
      component: ConfiguracoesAppUsuarios,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/chat',
      name: 'ConfiguracoesChat',
      component: ConfiguracoesChat,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/configuracoes/imposto',
      name: 'Imposto',
      component: Imposto,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  NProgress.set(0.1)
  let userData = localStorage.getItem('userData')
  let user = localStorage.getItem('user')
  let token = localStorage.getItem('token')
  let loggedout = (!userData || !user || !token || !validToken())
  if (!loggedout && (to.name === 'Login' || to.name === 'LoginUuid')) {
    next({ name: 'PainelInicial' })
  }
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (loggedout) {
      localStorage.removeItem('userData')
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      NProgress.done()
      next({ name: 'Login' })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach(() => {
  NProgress.set(0.9)
  // NProgress.done()
  setTimeout(() => NProgress.done(), 500)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js